import { QRGenerator } from '../components/QRGenerator';

export function QRPage() {
  // Obtener la URL base del sitio
  const baseUrl = window.location.origin;
  const linkTreeUrl = `${baseUrl}/links`;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#0052A3] mb-2">
            Generador de QR - LIEC
          </h1>
          <p className="text-gray-600">
            Página administrativa para generar el código QR
          </p>
        </div>

        <QRGenerator url={linkTreeUrl} size={300} />

        <div className="mt-8 p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold text-[#0052A3] mb-4">
            Información del enlace:
          </h3>
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <span className="font-semibold text-gray-700">URL:</span>
              <a 
                href={linkTreeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline break-all"
              >
                {linkTreeUrl}
              </a>
            </div>
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Nota:</strong> Esta página es solo para uso administrativo. 
                El enlace <code className="bg-white px-2 py-1 rounded">/links</code> no 
                está vinculado en ningún menú del sitio web, solo es accesible mediante 
                el código QR o conociendo la URL directa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
